import * as moment from 'moment';

/**
 * 日付ユーティリティ.
 */
export class DateUtil {

  /**
   * 現在日を指定のフォーマットで取得します.
   *
   * @param format フォーマット
   */
  static getCurrentDate(format: string): string {
    return moment().format(format);
  }

  /**
   * 指定日を指定のフォーマットで取得します.
   *
   * @param date 日付
   * @param format フォーマット
   */
  static format(date: Date | string | number, format: string): string {
    return moment(date).format(format);
  }

  /**
   * 指定日をYYYYMMDD形式で取得します.
   *
   * @param date 日付
   */
  static formatYYYYMMDD(date: Date | string | number): string {
    return this.format(date, 'YYYYMMDD');
  }

  /**
   * 指定日をMM/DD形式で取得します.
   *
   * @param date 日付
   */
  static formatMMDD_SLASH(date: Date | string | number): string {
    return this.format(date, 'MM/DD');
  }

  /**
   * 指定日をM/D（ddd）形式で取得します.
   * 例）4/1（月）
   *
   * @param date 日付
   */
  static formatMDddd(date: Date | string | number): string {
    return this.format(date, 'M/D（ddd）');
  }

  /**
   * 指定日をYYYY年MMM形式で取得します.
   * 例）2018年6月
   *
   * @param date 日付
   */
  static formatYYYYMMM(date: Date | string | number): string {
    return this.format(date, 'YYYY年MMM');
  }

  /**
   * 指定日をYYYY/M/D（ddd）形式で取得します.
   * 例）2018/6/4（月）
   *
   * @param date 日付
   */
  static formatYYYYMDddd(date: Date | string | number): string {
    return this.format(date, 'YYYY/M/D（ddd）');
  }

  /**
   * 指定日をYYYY-MM-DDTHH:mm形式で取得します.
   * （input type="datetime-local"で使用するため）
   * 例）2018-05-05T13:05
   *
   * @param date 日付
   */
  static formatForDatetimeLocal(date: Date | string | number): string {
    return this.format(date, 'YYYY-MM-DDTHH:mm');
  }

  /**
   * 指定された日数を調整（増減）して取得します.
   *
   * @param date 日付オブジェクト
   * @param adjust 調整する日数（2日後の場合：2、3日前の場合：-3）
   */
  static adjustWithDays(date: Date, adjust: number): Date {
    return moment(date).add(adjust, 'days').toDate();
  }

  /**
   * 指定された月数を調整（増減）して取得します.
   *
   * @param date 日付オブジェクト
   * @param adjust 調整する月数（2ヶ月後の場合：2、3ヶ月前の場合：-3）
   */
  static adjustWithMonths(date: Date, adjust: number): Date {
    return moment(date).add(adjust, 'months').toDate();
  }

  /**
   * 日付文字列（YYYYMMDD形式）をDateオブジェクトに変換します.
   *
   * @param date 日付文字列（YYYYMMDD形式）
   */
  static parseYYYYMMDD(date: string): Date {
    return moment(date, 'YYYYMMDD').toDate();
  }

  /**
   * 日付文字列（YYYYMMDDHHmm形式）をDateオブジェクトに変換します.
   *
   * @param date 日付文字列（YYYYMMDDHHmm形式）
   */
  static parseYYYYMMDDHHmm(date: string): Date {
    return moment(date, 'YYYYMMDDHHmm').toDate();
  }

  /**
   * 日付文字列（YYYYMMDDHHmmss形式）をDateオブジェクトに変換します.
   *
   * @param date 日付文字列（YYYYMMDDHHmmss形式）
   */
  static parseYYYYMMDDHHmmss(date: string): Date {
    return moment(date, 'YYYYMMDDHHmmss').toDate();
  }

  /**
   *  日付文字列（YYYY-MM-DDTHH:mm形式）をDateオブジェクトに変換します.
   *
   * @param date 日付文字列（YYYY-MM-DDTHH:mm形式）
   */
  static parseForDatetimeLocal(date: string): Date {
    return moment(date, 'YYYY-MM-DDTHH:mm').toDate();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-app/util/date-util.ts